import React, { useState, useEffect } from "react";
import api from "@api";

export function useBusinessTypeSelect(
  businessTypeFormValue: number,
  businessTypeFormStringValue?: string
) {
  const [selectedBusinessType, setSelectedBusinessType] = useState(0);
  const [selectedBusinessTypeName, setSelectedBusinessTypeName] = useState("");
  const [businessTypes, setBusinessTypes] = useState([]);
  const [isFetchingbusinessTypes, setFetchingBusinessTypes] = useState(false);

  useEffect(() => {
    setFetchingBusinessTypes(true);
    api.systemtype
      .getSystemTypes()
      .then((response) => {
        let bUnits: any = [];
        response.businessUnits.forEach((d: any) => {
          bUnits = [
            ...bUnits,
            {
              label: d.name,
              value: d.id,
            },
          ];
        });
        bUnits = bUnits.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        );
        bUnits = [
          {
            label: "No selection",
            value: 0,
          },
          ...bUnits,
        ];
        setBusinessTypes(bUnits);
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        setFetchingBusinessTypes(false);
      });
  }, []);

  useEffect(() => {
    if (businessTypes.length !== 0) {
      if (businessTypeFormValue) {
        setSelectedBusinessType(businessTypeFormValue);
      }
      if (businessTypeFormStringValue) {
        // TODO filter by id instead. Will requires some changes on the database.
        const businessTypesFindByName: any = businessTypes.find(
          (x: any) => x.label === businessTypeFormStringValue
        );
        console.log(businessTypesFindByName);
        setSelectedBusinessType(businessTypesFindByName?.value);
      }
    }
    return () => {
      setSelectedBusinessType(0);
    };
  }, [businessTypes]);

  const handleBusinessTypeChange = (event: any) => {
    setSelectedBusinessType(event.target.value);
  };

  return {
    businessTypes,
    isFetchingbusinessTypes,
    selectedBusinessType,
    selectedBusinessTypeName,
    setSelectedBusinessType,
    setSelectedBusinessTypeName,
    handleBusinessTypeChange,
  };
}
